import * as React from 'react';
import {
  ScheduleSpeakerName,
  ScheduleSpeakerPosition,
  ScheduleSpeakerContainer,
} from './ScheduleSpeaker.style';

const ScheduleSpeaker = ({ isInPerson, speakerDetails }) => {
  const {
    speaker_name: speakerName,
    speaker_position: speakerPosition,
  } = speakerDetails;
  return (
    <ScheduleSpeakerContainer>
      <ScheduleSpeakerName isInPerson={isInPerson}>
        {speakerName.text}
      </ScheduleSpeakerName>
      <ScheduleSpeakerPosition
        isInPerson={isInPerson}
        onlyPosition={speakerName.text === '' ? true : false}
      >
        {speakerPosition.text}
      </ScheduleSpeakerPosition>
    </ScheduleSpeakerContainer>
  );
};
export default ScheduleSpeaker;
